import { TCity, TError } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../members/axios';

export const getCityByIdQueryKey = (id: number | undefined) => ['geography', 'cities', id] as const;

export const useGetCityByIdQuery = (id: number | undefined) =>
  useQuery<TCity, TError>({
    queryKey: getCityByIdQueryKey(id),
    queryFn: async () => {
      const { data } = await axios.get<TCity>(`geography/cities/${id}`);
      return data;
    },
    enabled: !!id,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
